import { updateModel } from '../../data/Model'
import { requestAPI } from '../../data/api'

export default function getClients() {
	updateModel(model => {
		model.clients.status.handle = 'loading'
		return model
	})

	return requestAPI('/hubs', 'GET').then(clients => {
		console.log(clients.length)
		updateModel(model => {
			if (clients.length > 0) {
				model.clients.data = clients
				model.clients.data.sort((a, b) => {
					if (a.name < b.name) return -1
					if (a.name > b.name) return 1
					return 0
				})
				model.clients.mainClients = model.clients.data.filter(
					client => client.is_main_client,
				)
				model.clients.newScanningClients = clients.filter(
					client => !client.is_main_client,
				)
				model.clients.data.clients = model.clients.data.hubs // TODO remove this dirty fix
			}
			model.clients.status.handle = 'loaded'
			model.clients.status.timestamp = new Date()
			return model
		})
	})
}
